import { Component, Input, OnInit } from '@angular/core';
import { ViewCell } from '../ofbiz-form-model';

@Component({
  selector: 'ubs-ofbiz-cell-image',
  template: `<img src={{imageUrl}}/>`,
  styleUrls: ['./ofbiz-cell-image.component.scss']
})
export class OfbizCellImageComponent implements ViewCell, OnInit {
  @Input() value: string | number;
  @Input() rowData: any;
  @Input() field:any;
  @Input() baseUrl:string;
  imagePartUrl:string;
  imageUrl:string

  ngOnInit(): void {
    console.log(this.baseUrl)
    //Remove leading slash in value
        //value = value.replace(/^\//, '');
        //Remove the path from the baseUrl
    const parsedUrl = new URL(this.baseUrl);
    let imageBaseUrl = `${parsedUrl.protocol}//${parsedUrl.hostname}${parsedUrl.port ? `:${parsedUrl.port}` : ''}`;
    this.imageUrl = imageBaseUrl+this.value.toString()
  }

  
  
}
